import {
  GAME_MOVES_KEY,
  deriveBeerPong,
  gameDocName,
  type BeerPongMove,
  type BeerPongState,
} from '@awwyeah/shared';
import type * as Y from 'yjs';
import { useYArray, useYDoc } from '../../sync';

/**
 * A Beer Pong match's move log (`game:<id>`, `Y.Array<BeerPongMove>`) plus the derived racks
 * — the sibling of `usePoolMoves`, and the same append-only contract: the racks are never
 * stored, only ever replayed from the throws. Each entry is one whole turn including the
 * thrower's outcome snapshot, so `deriveBeerPong` needs no simulator to rebuild the game
 * (see `packages/shared/src/modules/games/beerpong.ts`).
 */
export function useBeerPongMoves(
  gameId: string,
  playerIds: readonly [string, string],
): {
  doc: Y.Doc;
  movesArray: Y.Array<BeerPongMove>;
  moves: BeerPongMove[];
  state: BeerPongState;
} {
  const doc = useYDoc(gameDocName(gameId));
  const { array, items } = useYArray<BeerPongMove>(doc, GAME_MOVES_KEY);
  const state = deriveBeerPong(items, playerIds);
  return { doc, movesArray: array, moves: items, state };
}
